import { ReactNode, useEffect } from "react";
import { FormProvider, useForm, useWatch } from "react-hook-form";
import { TPopulatedForm } from "../../hooks/applications.hooks";
import { RenderDocumentConfigs, RenderField } from "../RenderField/RenderField";

export function RenderStep({
  step,
  children,
  defaultValues,
  onChangeService,
}: {
  defaultValues?: Record<string, any>;
  children: (_: ReturnType<typeof useForm>) => ReactNode | ReactNode[];
  onChangeService: (service: number) => unknown;
  step: TPopulatedForm;
}) {
  const formMethods = useForm({
    defaultValues: { ...defaultValues },
    mode: "onChange",
    shouldFocusError: true,
  });

  const service = useWatch({
    name: "name_of_service",
    control: formMethods.control,
    defaultValue: Number(defaultValues?.name_of_service) || undefined,
  });

  useEffect(() => {
    onChangeService(service);
  }, [service]);

  const { formState } = formMethods;
  const { isValid } = formState;
  console.log("fields & document", step.fields, step.documentConfigs)
  return (
    <FormProvider {...formMethods}>
      <form
        noValidate
        id="add-application-form"
        onSubmit={formMethods.handleSubmit(() => null)}
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-10">
          {(step?.fields || [])?.map((field) => (
            <div key={`field-${field.id}`}>
              <RenderField field={field} />
            </div>
          ))}
        </div>
        <RenderDocumentConfigs configs={step.documentConfigs || []} />
        {children(formMethods)}
      </form>
    </FormProvider>
  );
}
